// utils
import i18n from 'config/i18n';
import { getLocale } from 'utils/date';

const t = i18n.getFixedT(getLocale(), 'common', 'mrp');

export const getFormattedTimeStep = (step: number) => {
  if (step > 60) return `${step / 60} ${t('hours.singular')}`;
  else if (step === 60) return `${step / 60} ${t('hours.singular')}`;
  else if (step < 60 && step > 1) return `${step} ${t('minutes.plural')}`;
  else if (step === 1) return `${step / 60} ${t('minutes.singular')}`;

  return `${step} ${t('minutes.plural')}`;
};
